// todo https://stackoverflow.com/questions/71482650/how-to-abstract-environmental-js-class-implementations
import { countries, states, addresses, formations, works, referenceItemPreviews, activeReferenceObjects } from "./MockWebPlatformAdapterFixtures";
export default class MockWebPlatformAdapter {
  request(method, relativePath, data, onSuccess, onError) {
    switch (relativePath) {
      case 'rpc/show_privacy_policy':
        return;
      default:
        const response = {
          data: []
        };
        onSuccess(response);
        return;
    }
  }
  getLocale() {
    return 'de_DE';
  }
  getLoginInformation(shortLocale, onSuccess) {
    // const singleMemberTypeId = 42;
    // const corporateMemberTypeId = 46;
    const subsidiaryCompanyMemberTypeId = 47;
    const mockUser = {
      member_type: {
        id: subsidiaryCompanyMemberTypeId
      }
    };
    const response = {
      data: [mockUser]
    };
    onSuccess(response);
  }
  getCustomerData(user, onSuccess) {
    const mockCustomer = {
      sia_id: user.getSiaId(),
      login_email: 'mock@local.local'
    };
    const response = {
      data: [mockCustomer]
    };
    onSuccess(response);
  }
  getCountries(shortLocale, onSuccess) {
    const response = {
      data: countries
    };
    onSuccess(response);
  }
  getStates(shortLocale, onSuccess) {
    const response = {
      data: states
    };
    onSuccess(response);
  }
  getAddressesForMemberTypeSingle(shortLocale, onSuccess) {
    const response = {
      data: addresses
    };
    onSuccess(response);
  }
  getCustomerDataOfMemberTypeSingle(shortLocale, onSuccess) {
    const response = {
      data: [{
        addresses_matrix: {
          contact: {
            id: addresses[0].id
          },
          delivery: {
            id: addresses[0].id
          },
          invoice: {
            id: addresses[0].id
          }
        },
        diploma_title: ''
      }]
    };
    onSuccess(response);
  }
  getCustomerDataOfMemberTypeCorporate(shortLocale, onSuccess) {
    const response = {
      data: [{
        sia_id: '1234',
        login_email: 'login_email',
        name: 'name',
        additional_name: 'additional_name',
        lang: 'de_DE',
        // foundation_date: '01.01.2000',
        foundation_date: null,
        company_uid: 'company_uid',
        // company_uid: null,
        contract_file: 'contract_file',
        // contract_file: null,
        addresses_matrix: {
          contact: {
            type: 'contact',
            id: 46461,
            label: null
          },
          invoice: {
            type: 'invoice',
            id: 77020,
            label: '0001'
          },
          delivery: {
            type: 'delivery',
            id: 46461,
            label: null
          }
        },
        work_branches: [{
          id: 36,
          code: 'A',
          name: 'Andere'
        }],
        work_specialisations: [{
          id: 218,
          code: 'A',
          name: 'Architektur'
        }]
      }]
    };
    onSuccess(response);
  }
  getIndustrySectors(shortLocale, onSuccess) {
    const response = {
      data: [{
        id: 36,
        code: 'A',
        name: 'Andere'
      }]
    };
    onSuccess(response);
  }
  getAreasOfActivity(shortLocale, onSuccess) {
    const response = {
      data: [{
        id: 218,
        code: 'A',
        name: 'Architektur'
      }]
    };
    onSuccess(response);
  }
  getAddressesForMemberTypeCorporate(shortLocale, onSuccess) {
    this.getAddressesForMemberTypeSingle(shortLocale, onSuccess);
  }
  getInvoices(shortLocale, onSuccess) {
    const data = [{
      "type": "out_invoice",
      "number": "111",
      "title": "Invoice 111",
      "creation_date": "2020-01-02",
      "due_date": "2020-02-19",
      "amount": 425,
      "status": "paid"
    }, {
      "type": "out_invoice",
      "number": "222",
      "title": "Invoice 222",
      "creation_date": "2021-02-01",
      "due_date": "2021-03-25",
      "amount": 425,
      "status": "paid"
    }];
    const response = {
      data: data
    };
    onSuccess(response);
  }
  getFormationSingle(shortLocale, onSuccess) {
    const response = {
      data: formations
    };
    onSuccess(response);
  }
  getWorkSingle(shortLocale, onSuccess) {
    const response = {
      data: works
    };
    onSuccess(response);
  }
  getProfessionalNetworksSingle(shortLocale, onSuccess) {
    const networks = {
      "linkedin": 'linkedin url',
      "xing": 'xing url'
    };
    const response = {
      data: [networks]
    };
    onSuccess(response);
  }
  getWorkBranchesSingle() {}
  getWorkSpecializationsSingle() {}
  getActiveReferenceObjects(shortLocale, onSuccess) {
    const response = {
      data: activeReferenceObjects
    };
    onSuccess(response);
  }
  getOwnerReferenceObjects(shortLocale, onSuccess) {
    const response = {
      data: referenceItemPreviews
    };
    onSuccess(response);
  }
}